import { render } from "./LearndativitySGVMovil.vue?vue&type=template&id=7ab73100"
import script from "./LearndativitySGVMovil.vue?vue&type=script&lang=js"
export * from "./LearndativitySGVMovil.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__